import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const startEmailSubscriptionFormSchema = yup
  .object({
    email: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .email()
      .required()
      .label("E-mail"),
  })
  .required();

export type StartEmailSubscriptionSchema =
  typeof startEmailSubscriptionFormSchema.__outputType;
